import React, {useState} from "react";
import {Nav, Navbar, NavItem} from "reactstrap";
import {NavLink, useHistory} from "react-router-dom";
import {connect} from "react-redux";
import {IStore} from "../../redux/defaultStore";
import {addError, decrementLoading, incrementLoading, logout, toggleSideBar} from "../../redux/meta/MetaActions";
import AssetManager from "../assetManager/AssetManager";
import {AdminApi} from "client";
import getConfig from "../../utils/getConfig";

interface IProps {
	token?: string;
	dispatch?: any;
	sideBarVisible?: boolean;
}

const SideBarInner: React.FC<IProps> = (props: IProps) => {

	const history = useHistory();
	const [showAssetManager, setShowAssetManager] = useState(false);

	function toggleAssetManager(e): void {
		if (e) {
			e.preventDefault();
		}
		setShowAssetManager(!showAssetManager);
	}

	function closeSideBarHelper(): void {
		if (props.sideBarVisible) {
			props.dispatch(toggleSideBar(false));
		}
	}

	function logoutDispatcher(e): void {
		if (e) {
			e.preventDefault();
		}

		closeSideBarHelper();
		props.dispatch(logout());
		history.push("/");
	}

	async function runAdapters(): Promise<void> {
		props.dispatch(incrementLoading());

		try {
			await new AdminApi(getConfig(props.token)).adminRunAdaptersGet();
		} catch (e) {
			props.dispatch(addError(e));
		}

		props.dispatch(decrementLoading());
	}

	return (
		<React.Fragment>
			<AssetManager
				isOpen={showAssetManager}
				allowSelect={false}
				onClose={toggleAssetManager}
			/>

			<div className="w-100">
				<Navbar color="black" dark>
					<Nav navbar className="w-100">
						<NavItem>
							<NavLink exact to="/dashboard" onClick={closeSideBarHelper}
							         className="text-decoration-none nav-link">Dashboard</NavLink>
						</NavItem>

						<NavItem>
							<NavLink exact to="/manage-admins" onClick={closeSideBarHelper}
							         className="text-decoration-none nav-link">Manage Admins</NavLink>
						</NavItem>

						<NavItem>
							<NavLink exact to="/manage-users" onClick={closeSideBarHelper}
							         className="text-decoration-none nav-link">Manage Users</NavLink>
						</NavItem>

						<NavItem>
							<NavLink exact to="/custom-dropdown-manager" onClick={closeSideBarHelper}
									 className="text-decoration-none nav-link">Manage Custom Dropdowns</NavLink>
						</NavItem>

						<NavItem>
							<NavLink exact to="/custom-csv-manager" onClick={closeSideBarHelper}
									 className="text-decoration-none nav-link">Manage Custom CSVs</NavLink>
						</NavItem>

						<NavItem>
							<NavLink exact to="/map-manager" onClick={closeSideBarHelper}
									 className="text-decoration-none nav-link">Manage Maps</NavLink>
						</NavItem>

						<NavItem>
							<NavLink exact to="/form-submission" onClick={closeSideBarHelper}
									 className="text-decoration-none nav-link">Form Management</NavLink>
						</NavItem>

						<NavItem>
							<a href="#" onClick={toggleAssetManager} className="nav-link">
								Open Asset Manager
							</a>
						</NavItem>

						<NavItem>
							<a href="#" onClick={runAdapters} className="nav-link">
								Run Adapters
							</a>
						</NavItem>

						{props.token && (
							<NavItem>
								<a href="#" onClick={logoutDispatcher} className="nav-link text-danger">
									Logout
								</a>
							</NavItem>
						)}

						<hr className="bg-white w-100"/>

						<div className="text-white" style={{fontSize: "0.85rem"}}>
							<p className="mb-0">
								{process.env.REACT_APP_PROJECT_NAME}
							</p>
							<p className="mb-0">
								{process.env.REACT_APP_VERSION}
							</p>
						</div>
					</Nav>
				</Navbar>
			</div>
		</React.Fragment>
	);
};

export default connect((store: IStore, props: IProps) => {
	return {
		...props,
		token: store.metaStore.token,
		sideBarVisible: store.metaStore.sidebarVisible,
	}
})(SideBarInner);
